import api from '../..'

const destroyParticipant = (id: number) => {
  return api.delete(`administration/users/${id}`)
}

export default destroyParticipant
